import { FaPalette, FaEnvelope, FaShieldAlt } from 'react-icons/fa';
import { ENUM_PERMISSIONS } from './enums/enums.interface';
export const COLOR_PALETTE = [
    "#1F2B68", // Azul oscuro
    "#273593", // Azul fuerte
    "#1B365D", // Azul marino
    "#1565C0", // Azul
    "#283593", // Índigo
    "#4527A0", // Índigo oscuro
    "#6A1B9A", // Morado
    "#8E24AA", // Púrpura
    "#AD1457", // Rosa oscuro
    "#C62828", // Rojo
    "#D84315", // Naranja oscuro
    "#E65100", // Naranja
    "#EF6C00", // Naranja fuerte
    "#F9A825", // Amarillo oscuro
    "#2E7D32", // Verde
    "#1B5E20", // Verde oscuro
    "#00695C", // Verde azulado
    "#00838F", // Cyan oscuro
    "#0277BD", // Azul claro fuerte
    "#37474F", // Azul gris oscuro
];

export const  ENUM_TABS_OPTIONS={
    COLORS:' COLORES',
    SMTP:'SMTP',
    RENAPO:'RENAPO'
}
export const TABS_SYSTEM_CONFIGURATIONS = [
    { id: 'COLORES', icon: <FaPalette />,enum: ENUM_TABS_OPTIONS.COLORS,permission:ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_COLORS_READ},
    { id: 'SMTP', icon: <FaEnvelope />,enum: ENUM_TABS_OPTIONS.SMTP ,permission:ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_SMTP_READ},
    { id: 'RENAPO', icon: <FaShieldAlt />,enum: ENUM_TABS_OPTIONS.RENAPO ,permission:ENUM_PERMISSIONS.MOD_SYSTEM_CONFIGURATION_RENAPO_READ},
  ];